import styled from '@emotion/styled';
import {Typography, Box} from '@mui/material';
import theme from 'src/styles/theme';

export const LabelWrapper = styled(Box)<{isfiletype: string}>`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
`;

export const IconWrapper = styled(Box)<{isfiletype: string}>`
  fill: ${({isfiletype}) =>
    isfiletype === 'true' ? '#00000033' : '#00000080'};
  margin-right: 0.5rem;
`;

export const SelectedIconWrapper = styled(Box)`
  fill: ${theme.palette.primary.main};
  margin-right: 0.5rem;
`;

export const TextWrapper = styled(Typography)<{isfiletype: string}>`
  display: flex;
  flex-wrap: wrap;
  white-space: nowrap;
  color: ${({isfiletype}) =>
    isfiletype === 'true' ? '#00000080' : '#000000DE'};
  font-weight: ${({isfiletype}) => (isfiletype === 'true' ? '500' : '600')};
`;

export const SelectedTextWrapper = styled(Typography)`
  white-space: nowrap;
  color: ${theme.palette.primary.main};
  font-weight: '500';
`;

export const IconAndTextWrapper = styled('div')`
  display: flex;
  align-items: center;
`;

export const TreeItemWrapper = styled(Box)<{isfiletype: string}>`
  &:hover {
    .MuiTreeItem-content {
      background-color: transparent !important;
    }
  }
  .Mui-selected {
    background-color: transparent !important;
  }
  .Mui-focused {
    color: ${({isfiletype}) =>
      isfiletype ? `${theme.palette.primary.main}` : ''};
    background-color: transparent !important;
    .MuiBox-root {
      svg {
        fill: ${({isfiletype}) =>
          isfiletype === 'true' ? `${theme.palette.primary.main}` : ''};
      }
      p {
        color: ${({isfiletype}) =>
          isfiletype === 'true' ? `${theme.palette.primary.main}` : ''};
      }
    }
  }
`;

export const TextButtonAndIconContainer = styled('div')``;
